module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "sigil_toc_id_5"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/foreword"
    }
  }, [_vm._v("Foreword by Gabe Lyons")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/introduction"
    }
  }, [_vm._v("Introduction: Foreplay")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/part1#toc_marker-1"
    }
  }, [_c('b', [_vm._v("Part 1: Where Did All the Sexy Christians Go?")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chap"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch1#toc_marker-1-1"
    }
  }, [_vm._v("1 Oh My God! Sexuality Meets Spirituality")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch2#toc_marker-1-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Modesty Gone Mad")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch3#toc_marker-1-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Jesus . . . Sex Symbol?")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part2#toc_marker-2",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part 2: Bits, Bobs and Tricky Business")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch4#toc_marker-2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 The Eight "), _c('i', [_vm._v("Fun")]), _vm._v("damentals of Sex")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch5#toc_marker-2-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Gender Matters")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch6#toc_marker-2-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Bi Now, Gay Later?")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch7#toc_marker-2-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Limping Straight to Heaven")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch8#toc_marker-2-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Uncomfortable Sex Positions")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/part3#toc_marker-3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("Part 3: The Mission of Christian Sexuality")])])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch9#toc_marker-5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 The Bent Scapegoat")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch10#toc_marker-5-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Imago Gay")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC_chap"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch11#toc_marker-5-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Re-Sexing the Church")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/conclusion#toc_marker-5-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion: The Climax")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#toc_marker-5-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/praisefor#toc_marker-5-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('em', [_vm._v("Redeeming Sex")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/aboutauthor#toc_marker-5-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/forge#toc_marker-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Forge")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreivp#toc_marker-5-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 66
// module chunks = 0